import moment from 'moment';
import { get, set } from 'lodash';
import { isISO } from '@xbcb/js-utils';
import { getFullFormKeys } from '../getFullFormKeys';
export { unMomentize } from '@xbcb/js-utils';

// These are keys which we want to display the same regardless of where you are geographically.
// for example, for in-bonds, the time of closing is entered and displayed at the time that the event actually happened, unadjusted for time zones.
const localTimeKeys = [
  'permissionLetterDate',
  'previousDate',
  'actualDate',
  'importDate',
  'exportDate',
  'estimatedEntryDate',
  'inBondDate',
  'lfd',
  'printDate',
];
export const momentize = (initialValues) => {
  if (!initialValues) return initialValues;

  const fullFormKeys = getFullFormKeys({
    values: initialValues,
  });

  fullFormKeys.forEach((key) => {
    const value = get(initialValues, key);
    if (
      (isISO(value) ||
        key.endsWith('Month') ||
        key.endsWith('Date') ||
        key.endsWith('Time') ||
        key.endsWith('date') ||
        key.endsWith('passport.expiration') ||
        key.endsWith('arrival.time') ||
        key.endsWith('departure.time') ||
        key.endsWith('previousCbpInBond.date') ||
        key === 'lfd') &&
      !moment.isMoment(value)
    ) {
      set(initialValues, key, moment(value));
    }
  });
  return initialValues;
};
